import React, { useEffect, useState } from 'react'
import './styles.scss'
import { lang } from 'utils/helpers'
import { useDispatch, useSelector } from 'react-redux'
import inchatActions from 'redux/inchat/actions'
import NotResult from 'components/common/NotResult'
import Container from './Container/Container'
import { getNamesCardInChat } from 'utils/usersHelpers'
import { apiInchat } from 'api'
import { toastMessage } from 'utils/messages'

const Mentions = () => {
  const { user: operator } = useSelector(state => state)
  const dispatch = useDispatch()
  const [data, setData] = useState({})
  const conversations = data?.conversations || []
  const mentions = data?.mentions || []
  const reactions = data?.reactions || []
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    getData()
    dispatch(inchatActions.getTotalReactions())
  }, [])

  const getData = async () => {
    setLoading(true)
    try {
      const { data } = await apiInchat.showReactionsDetails(operator._id)
      setData(data)
    } catch (error) {
      toastMessage(lang('inchat_error_get_mentions_reactions'), 'error')
    }
    setLoading(false)
  }

  const getConversationAndUser = (conversationId, userId) => {
    if(!userId || !conversationId) return { conversation: {}, user: {} }
    const conversation = conversations.find(conv => conv._id === conversationId)
    const { usersInfo } = conversation
    const user = usersInfo.find(it => it._id === userId)
    return { conversation, user }
  }

  const updateDataMentions = () => {
    getData()
  }

  return (
    <div className='inchat-mentions'>
      <div className='inchat-mentions__header'>
        <span className='inchat-mentions__header--title'>
          {lang('dashboard_mentions-reactions')}
        </span>
      </div>
      {/* MENTIONS */}
      <div className='inchat-mentions__info'>
        {mentions.map((mention) => {
          const { conversation } = getConversationAndUser(mention.conversationId, mention.userId)
          return (
            <Container
              key={mention._id }
              message={mention}
              operator={operator}
              isReactions={false}
              title={
                <span className='inchat-mentions__info--title'><strong>{getNamesCardInChat([mention.user], '', '')}</strong> {lang('dashboard_has_mentioned')} {conversation.type === 'channel' ? `#${conversation.name}` : `${lang(`dashboard_${conversation.type}`)}`}</span>
              }
              updateDataMentions={updateDataMentions}
            />
          )}
        )}
        {/* REACTIONS */}
        {reactions.map(reaction => {
          const { user } = getConversationAndUser(reaction.conversationId, reaction.reactions[0].users[0])
          return (
            <Container
              key={reaction._id}
              message={{ ...reaction,
                user: operator,
                userId: reaction.userId + 1
              }}
              operator={operator}
              isReactions={true}
              title={
                <span className='inchat-mentions__info--title'><strong>{getNamesCardInChat([user], '', '')}</strong> {lang('dashboard_has_reacted_message')}</span>
              }
              updateDataMentions={updateDataMentions}
            />
          )}
        )}
        {mentions.length === 0 && reactions.length === 0 && !loading
          ? <NotResult message={lang('dashboard_no_mentions_reactions')} />
          : null
        }
      </div>
    </div>
  )
}

export default Mentions